import React, { useRef } from "react";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import DownloadIcon from "@mui/icons-material/Download";
import domtoimage from "dom-to-image";
import MemorialGraphic1080 from "./ShareMessageThumbnail";

type MemorialGraphicCardProps = {
  streamId?: string | number;
  fullName: string;
  birthDate: string;
  deathDate: string;
  funeralDateText: string;
  funeralStartTime: string;
  venueText: string;
  imageUrl: string;
  patternSvgUrl: string;
  livestreamedBy?: string;
};

const MemorialGraphicCard: React.FC<MemorialGraphicCardProps> = ({
  streamId,
  fullName,
  birthDate,
  deathDate,
  funeralDateText,
  funeralStartTime,
  venueText,
  imageUrl,
  patternSvgUrl,
  livestreamedBy = "MUZUKURU",
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const exportRef = useRef<HTMLDivElement>(null);

  const handleDownloadGraphic = async () => {
    try {
      if (!exportRef.current) {
        console.error("No memorial graphic node found to export");
        return;
      }

      await new Promise((resolve) => setTimeout(resolve, 150));

      const width = 1080;
      const height = 1080;

      const dataUrl = await domtoimage.toPng(exportRef.current, {
        width,
        height,
        cacheBust: true,
        bgcolor: colors.primary[900],
        style: {
          transform: "none",
          transformOrigin: "top left",
        },
      });

      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `memorial-graphic-${streamId ?? "unknown"}.png`;
      link.click();
    } catch (err) {
      console.error("Memorial graphic download failed", err);
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: 350,
        height: 400,
        backgroundColor: colors.primary[800],
        borderRadius: 1,
        overflow: "hidden",
        m: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          p: 1,
        }}
      >
        <Tooltip title="Download Share Message Graphic">
          <IconButton
            onClick={handleDownloadGraphic}
            sx={{
              "&:hover": {
                backgroundColor: colors.primary[900],
              },
            }}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <MemorialGraphic1080
        ref={exportRef}
        fullName={fullName}
        birthDate={birthDate}
        deathDate={deathDate}
        funeralDateText={funeralDateText}
        funeralStartTime={funeralStartTime}
        venueText={venueText}
        imageUrl={imageUrl}
        patternSvgUrl={patternSvgUrl}
        livestreamedBy={livestreamedBy}
        previewSize={330}
      />
    </Box>
  );
};

export default MemorialGraphicCard;
